import { FlatVsaaTag, VsaaTag } from "../models/VsaaTag";

export const getTag = (tagId: string | undefined, tags: FlatVsaaTag[]) => {
  const tag = tags.find((t) => t.id === tagId);

  if (!tag) {
    throw `Failed to find tag ${tagId} in tags`;
  }

  return tag;
};

export const getAncestors = (
  tag: FlatVsaaTag,
  ancestors: FlatVsaaTag[],
  allTags: FlatVsaaTag[]
) => {
  if (!tag.ancestorIds) {
    return ancestors;
  }

  return tag.ancestorIds.map((id) => getTag(id, allTags));
};

export const getAllAncestors = (
  tags: FlatVsaaTag[],
  allTags: FlatVsaaTag[]
) => {
  const allAncestors: FlatVsaaTag[] = [];

  tags.forEach((tag) => {
    allAncestors.push(...getAncestors(tag, [], allTags));
  });

  return allAncestors;
};

export const hasMultiTagFieldChanged = (
  firstSet: VsaaTag[] | undefined,
  secondSet: VsaaTag[] | undefined
) => {
  if (!firstSet && !secondSet) {
    return false;
  }

  if (firstSet?.length !== secondSet?.length) {
    return true;
  }

  // This should be impossible due to previous checks but this is here for linter.
  if (firstSet === undefined || secondSet === undefined) {
    throw new Error("Tag ids or existingRoles where undefined");
  }

  for (let i = 0; i < firstSet.length; i++) {
    if (firstSet[i].id !== secondSet[i].id) {
      return true;
    }
  }

  return false;
};

// Gets all tags matching the query
export const searchTags = (
  searchQuery: string,
  tags: FlatVsaaTag[]
): FlatVsaaTag[] => {
  const foundTags = tags.filter((t) => tagFound(t, searchQuery));

  return foundTags;
};

const tagFound = (tag: FlatVsaaTag, query: string): boolean => {
  if (tag.title.toLocaleLowerCase().indexOf(query.toLowerCase()) !== -1) {
    return true;
  }

  return false;
};

export const distinct = (value: string, index: number, array: string[]) => {
  return array.indexOf(value) === index;
};

export const hasDuplicateNameAtSameLevel = (
  title: string,
  parentId: string | undefined,
  allTags: FlatVsaaTag[],
  excludeTagId?: string
): boolean => {
  const normalizedTitle = title.trim().toLowerCase();

  // Find all tags at the same level under the same parent
  const siblings = allTags.filter((tag) => {
    // Exclude the tag being edited
    if (excludeTagId && tag.id === excludeTagId) {
      return false;
    }

    // Check if they share the same parent
    return tag.parentId === parentId;
  });

  // Check if any sibling has the same title
  return siblings.some(
    (sibling) => sibling.title.trim().toLowerCase() === normalizedTitle
  );
};

export const getParentIdFromAncestors = (
  ancestorIds: string[] | undefined
): string | undefined => {
  if (!ancestorIds || ancestorIds.length === 0) {
    return undefined;
  }
  return ancestorIds[ancestorIds.length - 1];
};
